
import { ComponentCreator, createComponentCreator, styleInject } from 'packages/css-component-modules';

const _css = `.Container_ef06ac32269ac77e{padding:16px 16px 0;background-color:var(--backgroundColor_88a384fa85f02b25);display:flex;justify-content:space-between;border-radius:12px;margin-bottom:16px}.Container_ef06ac32269ac77e.shadow_245e54c81b56c0aa{box-shadow:0 2px 5px 0 rgb(0 0 0/14%)}.IconContainer_75c6a8bfb46b4295{margin-right:8px}.MessageContainer_d6601e4c5d5e8b3f{margin:0;overflow:hidden;overflow-wrap:break-word}.CtaContainer_061f3b93de3c87af{display:inline-flex;text-decoration:none}.CloseIcon_185c287e2897c494{cursor:pointer;right:0;top:-7px;position:relative}.Wrapper_e061d3dd78917bb4{max-width:100%;display:flex;justify-content:space-between}.IconWrapper_9f81278730f1d701{padding-top:2px;margin-left:5px}.OverrideTitle_f13d1cf6e90844db{margin-bottom:4px}`;
styleInject(_css)

/** Container Props */
export type ContainerCCM = {
  /** Container Component Custom Properties */
  '$backgroundColor': string;

  /** Container Modifier Flags */
  '$shadow'?: boolean;
};
/** Base Container component */
export const Container: ComponentCreator<ContainerCCM> = createComponentCreator({
  "name": "Container",
  "base": "Container_ef06ac32269ac77e",
  "prop": {
    "$backgroundColor": "--backgroundColor_88a384fa85f02b25"
  },
  "mod": {
    "$shadow": "shadow_245e54c81b56c0aa"
  }
});


/** IconContainer Props */
export type IconContainerCCM = {
  /** IconContainer Component Custom Properties */
  // No custom properties found

  /** IconContainer Modifier Flags */
  // No modifiers classes found
};
/** Base IconContainer component */
export const IconContainer: ComponentCreator<IconContainerCCM> = createComponentCreator({
  "name": "IconContainer",
  "base": "IconContainer_75c6a8bfb46b4295",
  "prop": {},
  "mod": {}
});


/** MessageContainer Props */
export type MessageContainerCCM = {
  /** MessageContainer Component Custom Properties */
  // No custom properties found

  /** MessageContainer Modifier Flags */
  // No modifiers classes found
};
/** Base MessageContainer component */
export const MessageContainer: ComponentCreator<MessageContainerCCM> = createComponentCreator({
  "name": "MessageContainer",
  "base": "MessageContainer_d6601e4c5d5e8b3f",
  "prop": {},
  "mod": {}
});


/** CtaContainer Props */
export type CtaContainerCCM = {
  /** CtaContainer Component Custom Properties */
  // No custom properties found

  /** CtaContainer Modifier Flags */
  // No modifiers classes found
};
/** Base CtaContainer component */
export const CtaContainer: ComponentCreator<CtaContainerCCM> = createComponentCreator({
  "name": "CtaContainer",
  "base": "CtaContainer_061f3b93de3c87af",
  "prop": {},
  "mod": {}
});


/** CloseIcon Props */
export type CloseIconCCM = {
  /** CloseIcon Component Custom Properties */
  // No custom properties found

  /** CloseIcon Modifier Flags */
  // No modifiers classes found
};
/** Base CloseIcon component */
export const CloseIcon: ComponentCreator<CloseIconCCM> = createComponentCreator({
  "name": "CloseIcon",
  "base": "CloseIcon_185c287e2897c494",
  "prop": {},
  "mod": {}
});


/** Wrapper Props */
export type WrapperCCM = {
  /** Wrapper Component Custom Properties */
  // No custom properties found

  /** Wrapper Modifier Flags */
  // No modifiers classes found
};
/** Base Wrapper component */
export const Wrapper: ComponentCreator<WrapperCCM> = createComponentCreator({
  "name": "Wrapper",
  "base": "Wrapper_e061d3dd78917bb4",
  "prop": {},
  "mod": {}
});


/** IconWrapper Props */
export type IconWrapperCCM = {
  /** IconWrapper Component Custom Properties */
  // No custom properties found

  /** IconWrapper Modifier Flags */
  // No modifiers classes found
};
/** Base IconWrapper component */
export const IconWrapper: ComponentCreator<IconWrapperCCM> = createComponentCreator({
  "name": "IconWrapper",
  "base": "IconWrapper_9f81278730f1d701",
  "prop": {},
  "mod": {}
});


/** OverrideTitle Props */
export type OverrideTitleCCM = {
  /** OverrideTitle Component Custom Properties */
  // No custom properties found

  /** OverrideTitle Modifier Flags */
  // No modifiers classes found
};
/** Base OverrideTitle component */
export const OverrideTitle: ComponentCreator<OverrideTitleCCM> = createComponentCreator({
  "name": "OverrideTitle",
  "base": "OverrideTitle_f13d1cf6e90844db",
  "prop": {},
  "mod": {}
});

